import {CommonModule} from '@angular/common';
import {Component, OnInit} from '@angular/core';
import { Router, RouterModule } from '@angular/router';
import {CardModule} from 'primeng/card';
import {IconFieldModule} from 'primeng/iconfield';
import {InputIconModule} from 'primeng/inputicon';
import {MenuModule} from 'primeng/menu';
import {TranslationPipe} from '../../../pipes/translation.pipe';
import {ButtonModule} from 'primeng/button';
import {InputTextModule} from 'primeng/inputtext';
import {MenuItem} from 'primeng/api';
import {ScrollPanelModule} from 'primeng/scrollpanel';
import {FormsModule} from '@angular/forms';
import {CustomerClient, CustomerNameDto} from '../../../api/api-client';
import {FeedbackDataService} from '../../../services/feedback-data.service';
import {SubscriptionManager} from '../../../services/subscription-manager.service';
import { Ripple } from 'primeng/ripple';


@Component({
  selector: 'app-customers',
  imports: [CommonModule, RouterModule, MenuModule, CardModule, InputTextModule, InputIconModule, IconFieldModule, TranslationPipe, ButtonModule, ScrollPanelModule, FormsModule, Ripple],
  providers: [TranslationPipe, SubscriptionManager],
  templateUrl: './customers.component.html',
  styleUrl: './customers.component.scss'
})
export class CustomersComponent implements OnInit {
  loading!: boolean;
  items!: MenuItem[];
  filterItems!: MenuItem[];
  allCustomers!: CustomerNameDto[];
  // there is no char in typescript
  firstLastnameLetters: string[] = [];
  currentSorting!: string;

  filteredCustomers!: CustomerNameDto[];
  filterQuery!: string;

  constructor(
    private readonly subscriptionManager: SubscriptionManager,
    private readonly customerService: CustomerClient,
    public translationPipe: TranslationPipe,
    private readonly feedbackService: FeedbackDataService,
    private readonly router: Router
  ) {
    this.feedbackService.feedbackData = null;
  }

  ngOnInit(): void {
    this.items = [
      {
        label: this.translationPipe.transform('Customer'),
        iconClass: "material-icons !text-[16px]",
        icon: 'person',
        routerLink: '../customers/create'
      },
      {
        label: this.translationPipe.transform('Patient'),
        iconClass: "material-icons !text-[16px]",
        icon: "pets",
        routerLink: '../pets/create'
      }
    ];
    this.filterItems = [
      {label: this.translationPipe.transform('Sorting.ByLastname')},
      {label: this.translationPipe.transform('Sorting.ByFirstname')},
    ];
    this.subscriptionManager.call(
      this.customerService.getAllCustomerNames(),
      (x => {
        this.allCustomers = x.result;
        this.filteredCustomers = x.result;
        this.allCustomers.forEach(x => {
          let firstLetter = x.lastName[0];
          if (!this.firstLastnameLetters.includes(firstLetter)) {
            this.firstLastnameLetters.push(firstLetter);
          }
        });
        this.firstLastnameLetters = this.firstLastnameLetters.toSorted((a, b) => a < b ? -1 : 1)
      })
    );
    this.currentSorting = this.translationPipe.transform('Sorting.ByLastname');
  }

  getCustomersForFirstLetter(letter: string): any {
    if (this.currentSorting == this.translationPipe.transform('Sorting.ByLastname')) {
      return this.filteredCustomers.filter(x => x.lastName.startsWith(letter));
    } else if (this.currentSorting == this.translationPipe.transform('Sorting.ByFirstname')) {
      return this.filteredCustomers.filter(x => x.firstName.startsWith(letter));
    }
  }

  hasMaterialIconClass(item: MenuItem) {
    let classList = item.iconClass ?? "".split(" ");
    return classList.includes("material-icons")
  }

  isSortingActive(item: MenuItem) {
    return item.label == this.currentSorting;
  }

  toggleSorting(item: MenuItem) {
    if (item.label == this.currentSorting) {
      this.currentSorting = this.translationPipe.transform('Sorting.ByLastname');
    } else {
      this.currentSorting = item.label ?? "";
      this.filterQuery = ""
      this.filteredCustomers = this.allCustomers;
      this.firstLastnameLetters = []
      if (item.label == this.translationPipe.transform('Sorting.ByLastname')) {
        this.allCustomers.forEach(x => {
          let firstLetter = x.lastName[0];
          if (!this.firstLastnameLetters.includes(firstLetter)) {
            this.firstLastnameLetters.push(firstLetter);
          }
        });
      } else if (item.label == this.translationPipe.transform('Sorting.ByFirstname')) {
        this.allCustomers.forEach(x => {
          let firstLetter = x.firstName[0];
          if (!this.firstLastnameLetters.includes(firstLetter)) {
            this.firstLastnameLetters.push(firstLetter);
          }
        });
      }
      this.firstLastnameLetters = this.firstLastnameLetters.toSorted((a, b) => a < b ? -1 : 1)
    }
  }

  filterCustomers($event: Event) {
    this.filteredCustomers = this.allCustomers.filter(x => (x.firstName + x.lastName).toLocaleLowerCase().includes(this.filterQuery.toLocaleLowerCase()))
  }

  protected openNewCustomerPage() {
    this.router.navigate(['../loggedin/customers/create'])
  }
}
